import React from 'react'
import ScrollTracker from '../kit/ScrollTracker'
import * as THREE from 'three'
// import Superface from '../Superface'
import TWEEN, { Tween, Easing } from '@tweenjs/tween.js'
import MapControls from '../etc/three-modules/controls/MapControls'
import ZoomControls from './_ZoomControls'
import Superface from '../Superface'

const CAMERA_Z_MAX = 120;
const CAMERA_Z_MIN = 5;
const CAMERA_Z = 80;

const PLANE_SCALE_X = 5.4

let MAGNIFICATION = 1.8
const TWEEN_DURATION = 600

// const SCROLL_INTERVAL = 200

const TIMELINE_Z = 20
const TIMELINE_GUTTER = 1.2
const GRID_Z = 0
const GRID_GUTTER = 8
        
const AREAS = 'secteur'
const TIMELINE = 'timeline'

export default class ProjectsGrid extends React.Component{

    mouse = { x : 0, y: 0}
    planes = []
    targetMesh = false
    
    constructor(props){
        super(props)
        this.start = this.start.bind(this)
		this.stop = this.stop.bind(this)
        this.animate = this.animate.bind(this)
        this.handleResize = this.handleResize.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.onMouseDown = this.onMouseDown.bind(this)
        this.onMouseUp = this.onMouseUp.bind(this)
        this.handleMouseMove = this.handleMouseMove.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
        this.handleScrollEnd = this.handleScrollEnd.bind(this)
        this.state = {
            ready : false,
            mounted : false,
        }
    }

    //
    // ─── LIFE CYCLE ─────────────────────────────────────────────────────────────────
    //

    componentWillMount(){
        
        Superface.setProjectsViewMode(TIMELINE)
        this.initScene()
        this.currentProjectIndex = 0
        
        this.scroll = new ScrollTracker()
        
        if(this.props.projects.length > 0){
            this.loadImages(this.props.projects)
        }
        MAGNIFICATION = window.innerHeight / 325
        this.setState({
            ...this.state, mounted : false, ready : false, leave : false
        })
        this.start()

    }

    componentDidMount() {
    
        window.addEventListener('resize', this.handleResize)
        window.addEventListener('keydown', this.handleKeyDown )
        
        this.mount.appendChild(this.renderer.domElement)
		window.addEventListener('mousemove', this.handleMouseMove)
        this.mount.addEventListener('mousedown', this.onMouseDown)
        this.mount.addEventListener('mouseup', this.onMouseUp)
        
        this.setState({
            ...this.state, mounted : true
        })

        if( this.props.active ){
            this.controls.activate()
        }else{
            this.controls.dispose()
        }

    }

    activateScroll(){
        this.scroll.start()
        this.scroll.on( 'scroll', this.handleScroll )
        // this.scroll.on( 'scrollend', this.handleScrollEnd )
    }
    
    disposeScroll(){
        this.scroll.stop()
        // this.scroll.off( 'scrollend', this.handleScrollEnd )
        this.scroll.off( 'scroll', this.handleScroll )
    }

    handleScrollEnd(){
        if( this.props.isOnSingle ) return 
        this.isScrolling = false
        if( this.props.mode !== TIMELINE ) return
        this.scroll.reset()
        if( this.planeGroup.shouldAnim ) return
        this.setTargetScale(TIMELINE)
        this.setTimelinePositions()
        this.initPlanesAnimation(false, TIMELINE)
        this.initPlanesGroupAnimation(TIMELINE)
    }
    
    handleScroll(e){
        if( this.props.isOnSingle ) return 
        this.isScrolling = true
        const step = 180
        const scaleFactor = 0.0065

        const lastIndex = this.currentProjectIndex
        if( this.props.mode !== TIMELINE ) return
        if( this.planeGroup.shouldAnim ) return
        
        if( e.deltaY > 0 && this.planes[this.currentProjectIndex + 1]){
            this.planeGroup.position.x -= e.deltaY * 0.01
            const plane = this.planes[this.currentProjectIndex + 1]
            const currentPlane = this.planes[this.currentProjectIndex]
            plane.scale.x += e.deltaY * scaleFactor
            plane.scale.y = plane.scale.x / plane.ratio
            currentPlane.scale.x -= e.deltaY * scaleFactor
            currentPlane.scale.y = currentPlane.scale.x / currentPlane.ratio
        }
        if( e.deltaY < 0 && this.planes[this.currentProjectIndex - 1]){
            this.planeGroup.position.x -= e.deltaY * 0.01
            const plane = this.planes[this.currentProjectIndex - 1]
            const currentPlane = this.planes[this.currentProjectIndex]
            plane.scale.x -= e.deltaY * scaleFactor
            plane.scale.y = plane.scale.x / plane.ratio
            currentPlane.scale.x += e.deltaY * scaleFactor
            currentPlane.scale.y = currentPlane.scale.x / currentPlane.ratio
        }

        if(e.y > step){ 
            this.scroll.reset()
            // this.currentProjectIndex += 1
            // if( this.currentProjectIndex > this.props.projects.length - 1 ){
            //     this.currentProjectIndex = this.props.projects.length - 1
            //     return
            // } 
            this.increaseProjectIndex()
        }
        if(e.y < -step){
            this.scroll.reset()
            this.decreaseProjectIndex()
            // this.currentProjectIndex -= 1
            // if( this.currentProjectIndex < 0 ){
            //     this.currentProjectIndex = 0
            //     return
            // }
        }
        if( lastIndex !== this.currentProjectIndex ){
            Superface.setCurrentTimelineProjectIndex( this.currentProjectIndex )
            this.setTargetScale(TIMELINE)
            this.setTimelinePositions()
            this.initPlanesAnimation(false, TIMELINE)
            this.initPlanesGroupAnimation(TIMELINE)
        }
        console.log( 'current Index : ' + this.currentProjectIndex )
    }

    handleKeyDown(e){
        // console.log(e.keyCode)
        // if( e.keyCode === 32 ) this.stop()

        if( this.props.mode !== TIMELINE ) return
        if( this.planeGroup.shouldAnim ) return
        
        e = e || window.event;

        if (e.keyCode === 37) {
            // left arrow
            console.log('37')
            this.decreaseProjectIndex()
        }
        
        else if (e.keyCode === 39) {
            // right
            console.log('39')
            this.increaseProjectIndex()
            
        }
        Superface.setCurrentTimelineProjectIndex( this.currentProjectIndex )
        // Superface.setProjectsDate( this.planes[this.currentProjectIndex].date )
        // console.log( this.currentProjectIndex )
        this.setTargetScale(TIMELINE)
        this.setTimelinePositions()
        this.initPlanesAnimation(false, TIMELINE)
        this.initPlanesGroupAnimation(TIMELINE)
        
    }
    
    componentWillReceiveProps(new_props){
    
        if( new_props.active !== this.props.active){
            if( new_props.active ){
                this.controls.activate()
            }else{
                this.controls.dispose()
            }
        }

        if(new_props.projects.length !== this.props.projects.length && new_props.projects.length > 0){
            this.loadImages(new_props.projects)
        }
        
        if( new_props.mode !== this.props.mode && this.props.mounted ){
            
            this.setTargetScale(new_props.mode)
            this.setTimelinePositions()
            this.initPlanesAnimation(false)
            this.initCameraAnimation()
            this.initPlanesGroupAnimation()
            
            if(new_props.mode === TIMELINE){
                Superface.resetFilters('projet')
                this.activateScroll()
            }else{
                this.controls.activate()
                this.controls.enabled = true
                this.disposeScroll()
            }
        }
        

        if( this.props.areasFilters !== new_props.areasFilters &&
            !new_props.areasFilters.isEmpty()
        ){
            this.initPlanesFiltering()
        }

        if( new_props.isOnSingle !== this.props.isOnSingle ){
            if( new_props.isOnSingle ){
                this.setState({ ...this.state, ready:false, leave : false })
            }else if( this.props.isOnSingle ){
                this.setState({ ...this.state, ready:true, leave : false })
            }
        }
        
    }
    
    componentWillUnmount(){
        this.stop()
        this.controls.dispose()
        this.controls = null
        if( this.timeoutResize )  window.clearTimeout( this.timeoutResize )
        if( this.timeoutMousePos )  window.clearTimeout( this.timeoutMousePos )
        if( this.timeoutScroll ) window.clearTimeout( this.timeoutScroll )
        window.removeEventListener('mousemove', this.handleMouseMove)
        window.removeEventListener('resize', this.handleResize)
        this.mount.removeEventListener('mousedown', this.onMouseDown)
        this.mount.removeEventListener('mouseup', this.onMouseUp)
    }

    //
    // ─── INIT 3D ────────────────────────────────────────────────────────────────────
    //

    initScene(){
        this.scene = new THREE.Scene()
        this.scene.background = new THREE.Color(255,255,255) 
        this.camera = new THREE.PerspectiveCamera( 35, window.innerWidth / window.innerHeight, 0.1, 1000 )
        this.camera.position.z = CAMERA_Z
        this.camera.tween = new Tween ({ value : 0 })
        .to({ value : 1 }, TWEEN_DURATION * 2.1 )
        .easing( Easing.Quadratic.InOut )
        .onUpdate( tween => {
            this.camera.animProgress = tween.value
        }).onComplete( tween => { tween.value = 0 } )
       
        this.camera.tweenTL = new Tween ({ value : 0 })
        .to({ value : 1 }, TWEEN_DURATION / 1.6 )
        .easing( Easing.Quadratic.InOut )
        .onUpdate( tween => {
            this.camera.animProgress = tween.value
        }).onComplete( tween => { tween.value = 0 } )

        this.controls = this.setControls(this.camera)
        this.renderer = new THREE.WebGLRenderer({ antialias: true })
        this.renderer.setSize(window.innerWidth, window.innerHeight)
    }

    setControls(camera){
        
        let controls = new MapControls( camera );
        controls.minDistance = CAMERA_Z_MIN;
        controls.maxDistance = CAMERA_Z_MAX;
        controls.dynamicDampingFactor = 0.2;
        return controls

    }

    initPlanesGroup(){
        this.planeGroup = new THREE.Object3D()
        this.planeGroup.lastPos = { x : 0, y : 0, z : 0 }
        
        this.planeGroup.tween = new Tween ({ value : 0 })
        .to({ value : 1 }, TWEEN_DURATION * 2.1 )
        .easing( Easing.Quadratic.InOut )
        .onUpdate( tween => {
            this.planeGroup.animProgress = tween.value
        }).onComplete( tween => { tween.value = 0 } )
        
        this.planeGroup.tweenTL = new Tween ({ value : 0 })
        .to({ value : 1 }, TWEEN_DURATION / 1.6 )
        .easing( Easing.Quadratic.InOut )
        .onUpdate( tween => {
            this.planeGroup.animProgress = tween.value
        }).onComplete( tween => { tween.value = 0 } )
        
        this.planeGroup.tweenTLQuick = new Tween ({ value : 0 })
        .to({ value : 1 }, 200 )
        // .easing( Easing.Linear )
        .onUpdate( tween => {
            this.planeGroup.animProgress = tween.value
        }).onComplete( tween => { tween.value = 0 } )

    }

    loadImages(projects){
        
        this.planes = []
        this.imagesLoaded = 0
        this.imagesToLoad = 0
        
        this.initPlanesGroup()
        Superface.setLoading(true)
        projects.forEach( (project, i) => {
        
            // console.log( i + ' : ' + matiere.slug + ' : ' +  Superface.assetUrl(matiere.image.thumb_path) )
            const path = Superface.assetUrl(project.thumb.path)
 
            if( path != undefined && project.activity_area._id ){
                  
                this.imagesToLoad += 1
                var texture = new THREE.TextureLoader().load( 
                    path,
                    (texture) => {
                        // console.log( i + ' of ' + ( projects.length - 1 ) )
                        this.imagesLoaded += 1
                        texture.anisotropy = this.renderer.getMaxAnisotropy()
                        var planeMaterial = new THREE.MeshBasicMaterial( { map: texture } );
                        var geometry = new THREE.PlaneGeometry( 1, 1 );
                        var plane = new THREE.Mesh( geometry, planeMaterial )
                        
                        plane.ratio = texture.image.width / texture.image.height
                        plane.targetScale = { x : PLANE_SCALE_X, y : PLANE_SCALE_X / plane.ratio }
                        
                        plane.scale.x = plane.targetScale.x
                        plane.scale.y = plane.targetScale.y
                        
                        plane.slug = project.slug
                        plane.date = project.date.split('-')[0]

                        plane.isClickable = plane.medias !== undefined
                        let area = Superface.getProjectAreaById( project.activity_area._id )
                        plane.name = Superface.field(area, 'name')
                        plane.hasSingle = Superface.projectHasSingle(project)
                        plane.linkSlug = project.slug
                        plane.area = area.slug
                        plane.date = project.date
                        plane.projectIndex = i
                        
                        plane.tween = new Tween ({ value : 0 })
                        .to({ value : 1 }, TWEEN_DURATION * 2.1)
                        .easing( Easing.Cubic.InOut )
                        .onUpdate( tween => {
                            plane.animProgress = tween.value
                        }).onComplete( tween => { tween.value = 0 } )
                        
                        plane.tweenTL = new Tween ({ value : 0 })
                        .to({ value : 1 }, TWEEN_DURATION / 1.6 )
                        .easing( Easing.Cubic.InOut )
                        .onUpdate( tween => {
                            plane.animProgress = tween.value
                        }).onComplete( tween => { tween.value = 0 } )
                        
                        plane.tweenTLQuick = new Tween ({ value : 0 })
                        .to({ value : 1 }, 200 )
                        // .easing( Easing.Linear )
                        .onUpdate( tween => {
                            plane.animProgress = tween.value
                        }).onComplete( tween => { tween.value = 0 } )

                        plane.lastScale = plane.targetScale

                        this.planeGroup.add(plane)
                        
                        this.planes[i] = plane

                        // if( this.imagesLoaded === Math.round(this.imagesToLoad / 2 ) ){
                        //     // Superface.setloadProgress('inc')
                        // }
                        // console.log(this.imagesLoaded + '/' + this.imagesToLoad )
                        if( this.imagesLoaded >= this.imagesToLoad ){
                           // console.log(this.imagesLoaded + '/' + this.imagesToLoad )
                            if( !Superface.IS_MOBILE_OR_TABLET ){
                                
                                this.timeoutMount = setTimeout( () => {     
                                    this.projectsReady() 
                                }, 1200 ) 
                            
                            }else{
                                
                                this.projectsReady()
                            }

                        }
                        
                    }
                );
            }
        })
        
        
    }

    setGridPositions(setPosition = false){
        
        let window_ratio = window.innerWidth / window.innerHeight
        let n_col_square = Math.ceil( Math.sqrt( this.planes.length ) )
        
        const COL_LENGTH =  Math.ceil( n_col_square * window_ratio ) - 2
        let row_num = 0
        let col_num = 0
        
        this.planes.forEach( (plane, i) => {
            
            if( col_num >= COL_LENGTH ){
                col_num = 0
                row_num += 1
                // console.log( '# ---- new row ----#' )
            } 
            
            plane.gridPos = {
                x : col_num * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
                y : - row_num * ( PLANE_SCALE_X + GRID_GUTTER ) + ( 0.5 - Math.random()) * PLANE_SCALE_X ,
                z : GRID_Z - Math.random() * 20
            }

            if( setPosition ){
                plane.position.setX( plane.gridPos.x )
                plane.position.setY( plane.gridPos.y )
                plane.position.setZ( plane.gridPos.z )
                plane.lastPos = plane.position
            }
            col_num += 1

        })
        
        const frame_height = PLANE_SCALE_X + GRID_GUTTER
        const limitPanX = frame_height * ( COL_LENGTH - 1 ) / 2 - GRID_GUTTER * 0.5
        const limitPanY = frame_height * ( row_num ) / 2 - GRID_GUTTER * 0.5
        
        this.controls.minPanX = - limitPanX - 5
        this.controls.maxPanX = limitPanX + 5
        this.controls.minPanY = - limitPanY - 5
        this.controls.maxPanY = limitPanY + 5
        
        this.planeGroup.gridPos = {
            x : - limitPanX,
            y : limitPanY,
            z : 0
        }
        
    }

    setTimelinePositions(setPosition = false){
        
        this.planes.forEach( (plane,i) => {
            
            let baseX = 0
            if( i !== 0 ){
                baseX = this.planes[i-1].timelinePos.x
                baseX += this.planes[i-1].targetScale.x / 2
            }
            baseX += plane.targetScale.x / 2

            plane.timelinePos = {
                x : baseX + TIMELINE_GUTTER,
                y : 0,
                z : TIMELINE_Z
            } 
            if( setPosition ){
                plane.position.setX( plane.timelinePos.x )
                plane.position.setY( plane.timelinePos.y )
                plane.position.setZ( plane.timelinePos.z )
                plane.lastPos = plane.position
            }
            
        })

        this.planeGroup.timelinePos = {
            x : - this.planes[this.currentProjectIndex].timelinePos.x,
            y : 0,
            z : 0
        }
        
    }

    setTargetScale(mode, setScale){
        
        this.planes.forEach( (plane,i) => {
            if( i === this.currentProjectIndex && mode === TIMELINE ){
                
                plane.targetScale = {
                    x : PLANE_SCALE_X * MAGNIFICATION,
                    y : ( PLANE_SCALE_X * MAGNIFICATION ) / plane.ratio
                }
                
            }else{
                if( plane.targetScale.x !== PLANE_SCALE_X ){
                    plane.targetScale = {
                        x : PLANE_SCALE_X,
                        y : PLANE_SCALE_X / plane.ratio
                    }
                }
            }
            if( setScale ){
                plane.scale.setX( plane.targetScale.x )
                plane.scale.setY( plane.targetScale.y )
            }
        })
    }

    projectsReady(){
       
        Superface.setLoading(false)
        this.camera.position.setZ( CAMERA_Z )
        this.camera.lastPos = this.camera.position
        this.scene.add( this.planeGroup )
        this.setTargetScale(this.props.mode, true)
        this.setGridPositions(( Superface.IS_MOBILE ? true : false) )
        this.setTimelinePositions( (!Superface.IS_MOBILE ? true : false) )
        if( this.props.mode === TIMELINE ){
            this.planeGroup.position.x = this.planeGroup.timelinePos.x
            this.planeGroup.position.y = this.planeGroup.timelinePos.y
        }else{
            this.planeGroup.position.x = this.planeGroup.gridPos.x
            this.planeGroup.position.y = this.planeGroup.gridPos.y
        }
        this.planeGroup.lastPos = this.planeGroup.position

        this.activateScroll()
        this.setState({
            ...this.state, ready : true
        })
        
    }   

    initCameraAnimation(mode = AREAS){
        this.controls.enabled = false
        this.controls.dispose()
        this.camera.shouldAnim = true
        if ( mode === TIMELINE ){
            this.camera.tweenTL.start() 
        } else {
            this.camera.tween.start()
        }
    }

    initPlanesAnimation(mounting = false, mode = AREAS, fromMouse = false ){
        
        this.souldAnimPlanes = true
        
        this.planes.forEach( (plane, i) => {
            plane.shouldAnim = true
            if ( mode === TIMELINE && !fromMouse ) 
                plane.tweenTL.start()
            else if( mode === TIMELINE ){
                plane.tweenTLQuick.start()
            }else{
                plane.tween.start()
            }
        })
        
        
    }

    initPlanesFiltering(){
        this.planes.forEach( (plane, i) => {
            plane.shouldFilter = true
        })
    }

    initPlanesGroupAnimation(mode = AREAS, fromMouse ){
        this.planeGroup.shouldAnim = true
        if ( mode === TIMELINE && !fromMouse ) 
            this.planeGroup.tweenTL.start()
        else if( mode === TIMELINE ){
            this.planeGroup.tweenTLQuick.start()
        }else{
            this.planeGroup.tween.start()
        }
    }

    handleResize() {
        MAGNIFICATION = window.innerHeight / 285
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        // this.controls.handleResize()
        this.renderer.setSize( window.innerWidth, window.innerHeight );
        this.sceneDimension = this.project(window.innerWidth, window.innerHeight)
        this.setGridPositions()
        this.setTimelinePositions()
        // if( this.timeoutResize ) window.clearTimeout( this.timeoutResize )
        // this.timeoutResize = window.setTimeout( this.handleResize , 100)
    }

    onMouseDown(e){
        // alert('coucou')
        this.mouseDownTime = new Date()
        if( this.planes.length === this.props.projects.length ){
            const intersect = this.checkBrowserMouseIntersection( this.mouse.x, this.mouse.y, this.planes )
   
            // console.log(intersect)
            if(!intersect || intersect[0] === undefined ) return
            let obj = intersect.first().object
            this.targetMesh = obj
        }
    }

    onMouseUp(e){

        if( !this.targetMesh ) return

        const now = new Date()
		const timeDif = (now.getTime() - this.mouseDownTime.getTime()) / 1000
        const shortClick = timeDif < 0.3 ? true : false

        if(shortClick && this.targetMesh.slug !== undefined ){
            if( this.targetMesh.hasSingle ){
                this.controls.dispose()
                Superface.setCursor('default')
                this.setState({
                    ...this.state, leave : true
                })
                Superface.mapLeaving(true)
                this.timeoutLeave = setTimeout(()=>{
                    Superface.mapLeaving(false)
                    // Superface.goTo( Superface.uri('matieres') + '/' + this.targetMesh.linkSlug )
                    Superface.goTo( Superface.uri('projets') + '/' + this.targetMesh.linkSlug )
                    this.targetMesh = null
                }, 400)
            }
            // this.targetMesh = null
        }
        
    }

    handleMouseMove(e){
        if( !this.planes || !this.scene.children.length || this.props.isOnSingle || !this.state.ready ) return

        this.mouse.x = e.pageX
        this.mouse.y = e.pageY

        if( this.planes.length === this.props.projects.length ){
            const intersect = this.checkBrowserMouseIntersection( e.pageX, e.pageY, this.planes )
            if( intersect || intersect[0] !== undefined ){
                let plane = intersect.first().object
                
                let active = false
                this.props.areasFilters.forEach( area => {
                    if( area.slug === plane.area && area.active ){
                        active = true
                    }
                })
                if( !active ) return
                
                if( this.props.mode !== TIMELINE ){
                    if(this._projectNameFollow) this._projectNameFollow.style.display = 'block'
                    this.currentProjectIndex = plane.projectIndex
                }
                Superface.setCursor('pointer')
            }else{
                if(this._projectNameFollow) this._projectNameFollow.style.display = 'none'
                if( Superface.app().cursor !== 'default' ) Superface.setCursor('default')
            }
        }

        if( this.props.mode !== TIMELINE && this._projectNameFollow ){
            this._projectNameFollow.style.left = e.pageX + 20 + 'px'
            this._projectNameFollow.style.top = e.pageY - 20 + 'px'
        }

        
    }

    increaseProjectIndex(){
        this.currentProjectIndex += 1
        if( this.currentProjectIndex > this.props.projects.length - 1 ) this.currentProjectIndex = this.props.projects.length - 1
    }

    decreaseProjectIndex(){
        this.currentProjectIndex -= 1
        if( this.currentProjectIndex < 0 ) this.currentProjectIndex = 0 
    }

    //
    // ─── ANIMATE ────────────────────────────────────────────────────────────────────
    //
 
    start() {
		if (!this.frameId) this.frameId = requestAnimationFrame(this.animate)
    }
    
    stop() {
		cancelAnimationFrame(this.frameId)
	}

    moveObject(obj, target_coord, deceleration){
        
        let offset = {
            x : ( target_coord.x - obj.lastPos.x),
            y : ( target_coord.y - obj.lastPos.y),
            z : ( target_coord.z - obj.lastPos.z)
        }

        const Z = obj.lastPos.z + offset.z * deceleration * 0.8
        const X = obj.lastPos.x + offset.x * deceleration * 0.8
        const Y = obj.lastPos.y + offset.y * deceleration * 0.8 
        
        // console.log('plane ' + this.planes.indexOf(obj) + ' : ', X, Y, Z)
        
        obj.position.x = X
        obj.position.y = Y
        obj.position.z = Z

    }
    
    scaleObject(obj, target_scale, deceleration){
        
        let offset = {
            x : ( target_scale.x - obj.lastScale.x),
            y : ( target_scale.y - obj.lastScale.y),
        }

        const Y = obj.lastScale.y + offset.y * deceleration 
        const X = obj.lastScale.x + offset.x * deceleration 
        
        obj.scale.x = X
        obj.scale.y = Y
        
    }

    animate(){
        if( this.props.isOnSingle ) return this.frameId = window.requestAnimationFrame(this.animate)

        if( this.controls && this.controls.enabled ) this.controls.update()
        
        if( this.planes && this.planeGroup ){
            
            if( this.planes.length === this.props.projects.length ){
                
                TWEEN.update()

                if( this.camera.shouldAnim ){
                    
                    const progress = this.camera.animProgress
                    if( progress !== 1 ){
                        let targetCoord = {
                            x : 0,
                            y : 0,
                            z : ( this.props.mode === TIMELINE ? CAMERA_Z : 20 )
                        }
                        // console.log('move camera to : ', targetCoord)
                        this.moveObject( this.camera, targetCoord, progress )
                    }else{
                        // console.log(this.camera.position)
                        this.camera.tween.stop()
                        this.camera.tweenTL.stop()
                        // console.log('-----------------------------')
                        this.camera.shouldAnim = false
                        Superface.canDoIt = true
                        if( this.props.mode !== TIMELINE ){
                            this.controls.activate()
                            this.controls.enabled = true
                        }
                        
                    }
                }
                
                this.planes.forEach( (plane, i) => {
                    if( plane.shouldAnim ){
                        // console.log( plane )
                        
                        const progress = plane.animProgress
                        
                        if( progress !== 1 ){
                            var targetCoord
                            if( this.props.mode === TIMELINE ){
                                
                                targetCoord = {
                                    x : plane.timelinePos.x,
                                    y : plane.timelinePos.y,
                                    z : plane.timelinePos.z,
                                }

                            }else{

                                targetCoord = {
                                    x : plane.gridPos.x,
                                    y : plane.gridPos.y,
                                    z : plane.gridPos.z,
                                }

                            }
                            
                            this.moveObject( plane, targetCoord, progress )
                            this.scaleObject( plane, plane.targetScale, progress )

                        }else{
                            plane.shouldAnim = false
                            // plane.tween.stop()
                            // plane.tweenTL.stop()
                        }
                    }
                })
                
                this.planes.forEach( (plane, i) => {

                    if( plane.shouldFilter ){
                        let active = false
                        this.props.areasFilters.forEach( area => {
                            if( area.slug === plane.area && area.active ){
                                active = true
                            }
                        })
                        if( active ){
                            this.planeGroup.add(plane)
                        }else{
                            this.planeGroup.remove(plane)
                        }
                        plane.shouldFilter = false
                    }

                    plane.lastScale = {
                        x : plane.scale.x,
                        y : plane.scale.y
                    }

                    plane.lastPos = { 
                        x : plane.position.x, 
                        y : plane.position.y, 
                        z : plane.position.z 
                    }

                });

                //
                // GROUP ANIM
                //

                if( this.planeGroup.shouldAnim ){
                    
                    const progress = this.planeGroup.animProgress
                    
                    if( progress !== 1 ){
                        
                        // console.log( this.props.mode )

                        const targetCoord = {
                            x : ( this.props.mode === TIMELINE ) ? this.planeGroup.timelinePos.x : this.planeGroup.gridPos.x,
                            y : ( this.props.mode === TIMELINE ) ? this.planeGroup.timelinePos.y : this.planeGroup.gridPos.y,
                            z : ( this.props.mode === TIMELINE ) ? this.planeGroup.timelinePos.z : this.planeGroup.gridPos.z,
                        }
                        // console.log('move group to : ', targetCoord)
                        this.moveObject( this.planeGroup, targetCoord, progress )
                    }else{
                        this.planeGroup.shouldAnim = false
                        // this.planeGroup.tween.stop()
                        // this.planeGroup.tweenTL.stop()
                        
                        this.planeGroup.lastPos = {
                            x : this.planeGroup.position.x, 
                            y : this.planeGroup.position.y, 
                            z : this.planeGroup.position.z 
                        }
                    }
                }   
            }

            this.planeGroup.lastPos = this.planeGroup.position
            this.camera.lastPos = this.camera.position

        }
        
        // this.lastCameraX = this.camera.position.x
        this.renderer.render(this.scene, this.camera)
        
        // if( this.planeGroup ){
            
        //     if( this.planeGroup.shouldAnim ||
        //         this.camera.shouldAnim ||
        //         this.isScrolling ||
        //         this.souldAnimPlanes || 
        //         this.controls._state !== -1
        //     ){
        //         this.shouldRender = true
        //     }else{
        //         this.shouldRender = false
        //     }
        //     console.log(' --> this.shouldRender : ' + this.shouldRender )
        // }

        this.frameId = window.requestAnimationFrame(this.animate)

    }

    project(x, y, targetZ){
		var vector = new THREE.Vector3();
		
		vector.set(
			( x / window.innerWidth ) * 2 - 1,
			- ( y / window.innerHeight ) * 2 + 1,
			0.5 );
		
		vector.unproject( this.camera );
		
		var dir = vector.sub( this.camera.position ).normalize();
        
        var distance = (( targetZ ? targetZ : 0 ) - this.camera.position.z) / dir.z;
		// var distance = ((targetZ || 0) - this.camera.position.z) / dir.z;
		
		var pos = this.camera.position.clone().add( dir.multiplyScalar( distance ) );
		return pos
    }
    
    checkBrowserMouseIntersection( mouseX, mouseY, threeObject){

		if(!this.camera || !this.renderer || !this.scene )
			return false

		if(!this.raycaster) 
			this.raycaster = new THREE.Raycaster();

		let mouse = {
			x : ( mouseX / this.renderer.domElement.clientWidth ) * 2 - 1,
			y : - ( mouseY / this.renderer.domElement.clientHeight ) * 2 + 1
		}		
		let intersects
		this.raycaster.setFromCamera( mouse, this.camera );
		if( threeObject && ( threeObject instanceof Array || threeObject === this.scene.children )){
			intersects = this.raycaster.intersectObjects( threeObject )
		}else if (threeObject) {
			intersects = this.raycaster.intersectObject( threeObject )
		}
		return intersects.length ? intersects : false
        
    }

    renderControls(){

        if( this.props.mode !== TIMELINE && !this.props.isOnSingle ){
            return <ZoomControls onClickPlus={() => { this.controls.zoomPlus() }} onClickMinus={() => { this.controls.zoomMinus() }} />
        }else{
            return <span></span>
        }
    }

    renderProjectsArrows(){
     
        if( this.props.projects.length === 0 || this.props.mode !== TIMELINE || Superface.IS_MOBILE ) return 
        
        return(
            <div style={{position : 'fixed', bottom:'4rem', textAlign:'center', zIndex : 400, width : '100%', display : 'flex', justifyContent : 'space-between' }}>
                <div className="arrow timeline-arrow" style={{marginLeft:'20vh'}} onClick={ () => { this.onArrowClick('left') } }>
                    <img style={{opacity:(this.props.currentTimeLineProjectIndex == 0 ? 0 : 1)}} src={require('../images/arrow-left.svg')} alt='arrow' />
                </div>
                <div className="arrow timeline-arrow" style={{marginRight:'20vh'}} onClick={ () => { this.onArrowClick('right') } }>
                    <img style={{opacity:(this.props.currentTimeLineProjectIndex == this.props.projects.length - 1 ? 0 : 1)}} src={require('../images/arrow-right.svg')} alt='arrow' />
                </div>
            </div>
        )
    }

    onArrowClick(direction){
        
        if( direction === 'left'){
            this.decreaseProjectIndex()
        }else{
            this.increaseProjectIndex()
        }
        Superface.setCurrentTimelineProjectIndex( this.currentProjectIndex )
        this.setTargetScale(TIMELINE)
        this.setTimelinePositions()
        this.initPlanesAnimation(false, TIMELINE)
        this.initPlanesGroupAnimation(TIMELINE)
    }

	render() {

        const margin = ( Superface.IS_MOBILE_OR_TABLET ? '2rem' : '2rem' )
        
		return (
            <div className={( this.state.ready ? 'map-loaded ' : '') + (this.state.leave ? 'map-leave' : '' )} style={{width : '100%', height:'100%', backgroundColor:'white'}}>
                
                <div
                    id="three-map-container"
                    style={{ width: '100%', height: '100%' }}
                    ref={(mount) => { this.mount = mount }}
                />
                
                <div style={{position:'absolute', bottom: margin, right: margin, zIndex: 400}}>
                    {this.renderControls()}
                </div>
                
                {this.renderProjectNameFollowMouse()}
                {this.renderProjectsArrows()}

            </div>
		)
    }

    renderProjectNameFollowMouse(){
        
        if( this.props.projects.length === 0 || this.props.mode === TIMELINE|| Superface.IS_MOBILE || this.props.isOnSingle ) return 
        
        return(
            <div ref={ el => this._projectNameFollow = el } className="projects-name-follow" style={{position : 'absolute', zIndex : 400}}>
                
                { Superface.field(this.props.projects[this.currentProjectIndex], 'name') }
                
            </div>
        )
    }
    
    
}


// WEBPACK FOOTER //
// ./src/components/ProjectsGrid.js